import { computed } from 'vue';

const minimumBalance = (payVat) => {
    let minBalance = 1000; // Example threshold
    if (payVat) {
        minBalance += 180; //18% vat
    }
    console.log('minimum Balance', minBalance);
    return minBalance;
}

/**
 * Checks if a wallet balance meets withdrawal criteria
 * @param {number} balance - The current wallet balance
 * @returns {boolean} - Whether withdrawal is allowed
 */
export const canWithdrawFromWallet = (balance, minBalance) => {
    return balance >= minBalance;
};

/**
 * Gets the withdrawal status message based on balance
 * @param {number} balance - The current wallet balance
 * @returns {string} - The status message
 */
export const getWithdrawalStatusMessage = (balance, minBalance) => {
    return canWithdrawFromWallet(balance, minBalance) 
        ? 'Available for withdrawal'
        : `Minimum balance not met (€${minBalance})`;
};

export const checkIfWeNeedToPayVat = (user) => {
    console.log(user);
    return user.address?.country === 'MT' && !user.vatExempt;
};

/**
 * Creates computed properties for withdrawal status
 * @param {Ref<number>} balanceRef - Vue ref containing the balance
 * @returns {Object} - Computed properties for withdrawal status
 */
export const useWalletWithdrawal = (balanceRef, user) => {
   if(!user) return {
    canWithdraw: false,
    withdrawalMessage: 'No user data available'
   }
    const payVat = computed(() => checkIfWeNeedToPayVat(user));
    console.log('payVat', payVat.value);
    const minBalance = computed(() => minimumBalance(payVat.value));
    const canWithdraw = computed(() => canWithdrawFromWallet(balanceRef.value, minBalance.value));
    const withdrawalMessage = computed(() => getWithdrawalStatusMessage(balanceRef.value, minBalance.value));

    return {
        canWithdraw,
        withdrawalMessage
    };
}; 


export const getStatusSeverity = (status) => {
    switch (status.toLowerCase()) {
        case 'approved':
            return 'info';
        case 'completed':
            return 'success';
        default:
            return 'danger';
    }
};